<template>
    <div class="manual-rule-list">
        <table class="tbl-inner">
            <caption>Manual Rule List</caption>
            <thead>
            <tr>
                <th class="check-col" scope="row">
                    <label>Compliant</label>
                </th>
                <th scope="row">
                    <label>Rule Info</label>
                </th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(rule,idx) in ruleList" :key="idx">
                <td class="txt-c">
                    <BaseCheckBox
                        :getValue="addToSelect"
                        :name="rule.ruleId || `cb${idx}`"
                        label=""
                        :checked="rule.ruleCmplRslt === 'P'"
                    />
                </td>
                <td class="detail-col">
                    <b-row>
                        <b-col>
                            <span class="rule-title">{{ rule.ruleTitl }}</span>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <span class="rule-desc">{{ rule.ruleDesc }}</span>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col class="rule-label">
                            <span v-for="(label, idx) in rule.ctgLabel" :key="idx" class="label mr-2 px-2">
                                {{ label }}
                            </span>
                        </b-col>
                    </b-row>
                </td>
            </tr>
            <tr v-if="ruleList.length === 0">
                <td class="data row" colspan="2">
                    <div class="none">
                        {{ $t('POLICY.RULE.NO_APPLIED_RULE') }}
                    </div>
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</template>
<script>
import {BCol, BRow} from "bootstrap-vue";
import BaseCheckBox from "../../common/BaseCheckBox.vue"

export default {
    name: "ManualRuleList",
    components: {BRow, BCol, BaseCheckBox},
    data() {
        return {
            selectedRule: {}
        }
    },
    props: {
        getSelectedRules: {
            type: Function,
            default: ()=>{}
        },
        ruleList: {
            type: Array,
            default: () => {
                return [{ruleTitl: "name", ruleDesc: "desc", ctgLabel: "ctgLabel"}]
            }
        }
    },
    methods: {
        addToSelect(name, value) {
            this.selectedRule = {
                ...this.selectedRule,
                [name]: value
            }
            this.getSelectedRules(this.selectedRule);
        }
    }
}
</script>
<style scoped>
.manual-rule-list {
    font-family: 'Noto Sans Korean', serif;
}

.txt-c {
    vertical-align: middle;
}

.data.row {
    display: table-cell;
}

th.check-col {
    width: 25%;
}

.rule-title {
    font-size: 16px;
    font-weight: 400;
}
.rule-desc {
    font-size: 14px;
    font-weight: 400;
}
.rule-label {
    display: inherit;
    font-size: 12px;
    margin: 8px 0;
    word-break: break-word;
}

.rule-label .label {
    border-radius: 4px;
    color: #4A90E2;
    border: 1px solid #4A90E2;
    margin: 2px 0;
    display: inline-block;
    
}

</style>



// WEBPACK FOOTER //
// src/components/compliance/components/ManualRuleList.vue